// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"181":"ded68ef5","968":"70b1b8f5"}[chunkId] + ".chunk.css";
};